/**
 * 開發工具路由 — 僅 dev 註冊（`import.meta.env.DEV`）。
 * build 後為空陣列；頁面皆以 route.lazy 動態載入，不進正式 bundle。
 */
const devRouteList = [
  {
    path: 'dev',
    handle: { title: '開發工具' },
    lazy: async () => ({
      Component: (await import('#/modules/infra/pages/DevToolsHubPage')).default,
    }),
  },
  {
    path: 'dev/stock-receipt-preview',
    handle: { title: '入庫明細預覽' },
    lazy: async () => ({
      Component: (
        await import('#/modules/imsMgmt/receipts/stockReceipt/pages/StockReceiptDetailPreview')
      ).default,
    }),
  },
  {
    path: 'layout-demo',
    handle: { title: 'Layout Demo' },
    lazy: async () => ({
      Component: (await import('#/modules/infra/pages/LayoutDemoPage')).default,
    }),
  },
  {
    path: 'table-demo',
    handle: { title: 'Table Demo' },
    lazy: async () => ({
      Component: (await import('#/modules/infra/pages/TableDemoPage')).default,
    }),
  },
  {
    path: 'dialog-demo',
    handle: { title: 'Dialog Demo' },
    lazy: async () => ({
      Component: (await import('#/modules/infra/pages/DialogDemoPage')).default,
    }),
  },
  {
    path: 'error-test',
    handle: { title: 'Error 測試' },
    lazy: async () => ({
      Component: (await import('#/modules/infra/pages/ErrorTestPage')).default,
    }),
  },
];

export const devRoutes = import.meta.env.DEV ? devRouteList : [];
